import axios from '@/config/axios';
import { useToast } from 'vue-toastification';

export default {
  name: 'AdminLayout',
  data() {
    return {
      displayName: 'Quản trị viên',
      userRoleLabel: 'Quản trị viên',
      isSidebarCollapsed: true,
      showProfileDropdown: false,
      layoutMode: localStorage.getItem('admin-layout-mode') || 'web',
      isMobileOrTablet: window.innerWidth < 992,
      isAdmin: false
    };
  },
  computed: {
    pageTitle() {
      return this.$route.meta?.title || 'Quản trị hệ thống';
    }
  },
  mounted() {
    this.loadUserInfo();
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('click', this.handleOutsideClick);
    this.handleResize();
    this.updateBodyClass();
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('click', this.handleOutsideClick);
    document.body.classList.remove('layout-mode-app');
  },
  methods: {
    loadUserInfo() {
      const currentAccountStr = localStorage.getItem('current-account');
      if (currentAccountStr) {
        try {
          const currentAccount = JSON.parse(currentAccountStr);
          this.displayName = currentAccount.name || currentAccount.fullName || currentAccount.username || 'Quản trị viên';
          
          if (currentAccount.authority) {
            let roles = [];
            try {
              roles = typeof currentAccount.authority === 'string' ? JSON.parse(currentAccount.authority) : currentAccount.authority;
            } catch (err) {
              roles = [currentAccount.authority];
            }
            if (Array.isArray(roles)) {
              if (roles.includes('ROLE_ADMIN')) {
                this.userRoleLabel = 'Quản trị viên';
                this.isAdmin = true;
              } else if (roles.includes('ROLE_STAFF')) {
                this.userRoleLabel = 'Nhân viên';
                this.isAdmin = false;
              }
            } else {
              if (roles === 'ROLE_ADMIN') {
                this.userRoleLabel = 'Quản trị viên';
                this.isAdmin = true;
              } else if (roles === 'ROLE_STAFF') {
                this.userRoleLabel = 'Nhân viên';
                this.isAdmin = false;
              }
            }
          }
        } catch (e) {
          console.error('Error parsing admin info:', e);
        }
      }
    },
    toggleSidebar() {
      this.isSidebarCollapsed = !this.isSidebarCollapsed;
    },
    closeSidebar() {
      this.isSidebarCollapsed = true;
    },
    handleResize() {
      this.isMobileOrTablet = window.innerWidth < 992;
      if (window.innerWidth >= 992) {
        this.isSidebarCollapsed = false;
        if (this.layoutMode !== 'web') {
          this.layoutMode = 'web';
          localStorage.setItem('admin-layout-mode', 'web');
          this.updateBodyClass();
        }
      } else {
        this.isSidebarCollapsed = true;
      }
    },
    toggleProfileDropdown(e) {
      e.stopPropagation();
      this.showProfileDropdown = !this.showProfileDropdown;
    },
    handleOutsideClick() {
      this.showProfileDropdown = false;
    },
    handleLogout() {
      const toast = useToast();
      localStorage.removeItem('token');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('current-account');
      if (axios.defaults.headers.common) {
        axios.defaults.headers.common['Authorization'] = '';
      }
      toast.success('Đăng xuất thành công!', { position: "top-center" });
      this.$router.push('/login');
    },
    updateBodyClass() {
      if (this.layoutMode === 'app') {
        document.body.classList.add('layout-mode-app');
      } else {
        document.body.classList.remove('layout-mode-app');
      }
    },
    toggleLayoutMode() {
      this.layoutMode = this.layoutMode === 'app' ? 'web' : 'app';
      localStorage.setItem('admin-layout-mode', this.layoutMode);
      this.updateBodyClass();
      this.showProfileDropdown = false;
    }
  }
};
